import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps3/objection-reporting'
});
export default {
	init() {
		return httpClient.get('/init');
	},
	upload(file) {
		const formData = new FormData();
		formData.append('file', file);
		return httpClient.post('/file-upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
	},
	deleteFile(filename) {
		return httpClient.delete(`/file-delete/${filename}`);
	},
	finalize(model) {
		return httpClient.post('/finalize', model);
	}
};
